<!--
 * @Author: your name
 * @Date: 2020-10-15 14:11:15
 * @LastEditTime: 2020-10-29 22:18:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/uploadCase/index.vue
-->
<template>
  <div class="work-company-edit">
    <div class="name-title-edit">
      <span class="name-title-tag"></span>
      <span class="name-title-name">编辑公司信息</span>
      <Button type="text" @click="cencelCompany" style="margin-left:72%">
        <span style="color: #E56A69">取消</span>
      </Button>
      <Button
        type="primary"
        size="small"
        :loading="submitLading"
        :disabled="submitLading"
        @click="submitHandle"
        >保存</Button
      >
    </div>
    <div class="form">
      <Form
        ref="valivate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="公司logo" prop="avatarFileProps" style="width:340px">
          <z-upload
            v-if="filePolicy"
            :type="59"
            :ossKey="filePolicy"
            @success="uploadLogoSuccess"
            :format="['jpg', 'jpeg', 'JPG', 'JPEG', 'png', 'PNG']"
            class="cover"
            :progressBar="true"
            style="background: #fff;display:inline-block"
          >
            <div class="uoload-view">
              <div v-if="!formValidate.avatarFile">
                <span class="uoload-view-span">添加图片</span>
              </div>
              <img
                v-if="formValidate.avatarFile"
                :src="ossPrefix + formValidate.avatarFile.key"
                alt=""
              />
            </div>
          </z-upload>
        </FormItem>
        <Row>
          <Col span="12">
            <FormItem label="公司名称" prop="companyName" style="width:400px">
              <div style="margin-top:4px">
                {{ $route.query.name || '' }}
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="官网" prop="website" style="width:400px">
              <Input
                :maxlength="100"
                show-word-limit
                v-model="formValidate.website"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="12">
            <FormItem label="电话" prop="phone" style="width:400px">
              <Input
                :maxlength="100"
                show-word-limit
                v-model="formValidate.phone"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="邮箱" prop="email" style="width:400px">
              <Input
                :maxlength="100"
                show-word-limit
                v-model="formValidate.email"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>

        <FormItem label="公司地址" prop="locationIdProps" style="width:835px">
          <Row type="flex" :gutter="10">
            <Col :span="8">
              <Select
                name="province"
                @on-change="changeProvince"
                v-model="provinceId"
                placeholder="请选择省份"
              >
                <Option :value="p.id" :key="p.id" v-for="p in addressData">{{
                  p.name
                }}</Option>
              </Select>
            </Col>
            <Col :span="8">
              <Select
                name="city"
                v-model="cityId"
                @on-change="changeCity"
                placeholder="请选择城市"
              >
                <Option :value="c.id" :key="c.id" v-for="c in cityData">{{
                  c.name
                }}</Option>
              </Select>
            </Col>
            <Col :span="8">
              <Select
                name="zone"
                v-model="formValidate.locationId"
                placeholder="请选择区域"
              >
                <Option :value="z.id" :key="z.id" v-for="z in zoneData">{{
                  z.name
                }}</Option>
              </Select>
            </Col>
          </Row>
        </FormItem>

        <FormItem label="" prop="detailAddress" style="width:835px">
          <Input
            :maxlength="100"
            show-word-limit
            v-model="formValidate.detailAddress"
            placeholder="详细地址"
          ></Input>
        </FormItem>

        <FormItem label="公司介绍" prop="description" style="width:835px">
          <Input
            :maxlength="100"
            show-word-limit
            type="textarea"
            :rows="4"
            v-model="formValidate.description"
            placeholder="请输入"
          ></Input>
        </FormItem>

        <Row>
          <Col span="6">
            <FormItem label="公司项目" prop="">
              <z-upload
                v-if="filePolicy"
                :type="15"
                :ossKey="filePolicy"
                @success="uploadFilesSuccess"
                class="cover"
                :multiple="true"
                :progressBar="true"
                :format="['jpg', 'jpeg', 'png']"
                style="background: #fff;display:inline-block"
              >
                <div>
                  <div class="uoload-view">
                    <span class="uoload-view-span">添加图片</span>
                  </div>
                </div>
              </z-upload>
            </FormItem>
          </Col>
          <Col span="18">
            <FormItem
              v-if="
                formValidate.projectFileList &&
                  formValidate.projectFileList.length > 0
              "
              style="width:700px;margin-left:-25px"
            >
              <Row :gutter="20" style="margin-left:-80px">
                <Col
                  v-for="(item, index) in formValidate.projectFileList"
                  :key="index"
                  span="4"
                  style="overflow:hidden;width: 120px;height: 100px;margin-bottom:20px"
                >
                  <img
                    style="width:100%;height:100%;object-fit: cover;"
                    :src="ossPrefix + item.key"
                    alt=""
                  />
                </Col>
              </Row>
            </FormItem>
          </Col>
        </Row>
        <div class="upload-desc">
          <i class="iconfont icon-jinggao"></i>
          只能上传jpg/png格式文件，文件不能超过5M
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
const defaultAddress = {
  locationId: '',
  detailAddress: '',
  userName: '',
  userMobile: '',
  isDefault: 0,
  zipCode: '',
}
import axios from 'axios'
import LayOut from './layout'
export default {
  props: {
    companyDetail: {
      type: [Object, String],
      default: null,
    },
  },
  data() {
    return {
      filePolicy: '',
      submitLading: false,
      formValidate: {
        avatarFileProps: '默认',
        avatarFile: '',
        companyName: this.$route.query.name,
        website: '',
        phone: '',
        email: '',
        locationIdProps: '默认',
        locationId: '',
        detailAddress: '',
        description: '',
        projectFileListPro: '默认',
        projectFileList: [],
      },
      ruleValidate: {
        avatarFileProps: [
          {
            required: true,
            message: '请上传公司LOGO',
            trigger: 'blur',
          },
        ],
        avatarFile: [
          {
            required: true,
            message: '请上传公司LOGO',
            trigger: 'blur',
          },
        ],
        companyName: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur',
          },
        ],
        website: [
          {
            required: true,
            message: '请输入公司官网',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入电话',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur',
          },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
        ],
        locationIdProps: [
          {
            required: true,
            message: '请选择地址',
            trigger: 'change',
          },
        ],
        locationId: [
          {
            required: true,
            message: '请选择地址',
            trigger: 'change',
          },
        ],
        detailAddress: [
          {
            required: true,
            message: '请输入公司详细地址',
            trigger: 'blur',
          },
        ],
        description: [
          {
            required: true,
            message: '请输入公司详细介绍',
            trigger: 'blur',
          },
        ],
        projectFileListPro: [
          {
            required: true,
            message: '请上传公司项目',
            trigger: 'blur',
          },
        ],
      },

      addressData: [],
      cityData: [],
      zoneData: [],
      provinceId: '',
      cityId: '',
      detailAddress: '',
      address: {},
    }
  },
  components: { LayOut },
  methods: {
    // 取消
    cencelCompany() {
      this.$emit('cencelCompanyHandle')
    },
    async getOssKey(type) {
      let res = await axios.get(`/designer_api/files/policy?type=${type}`)
      this.filePolicy = res
    },
    submitHandle() {
      this.$refs['valivate'].validate((valid) => {
        if (valid) {
          this.submitLading = true
          if (!this.formValidate.avatarFile) {
            this.$Message.error('请上传公司LOGO！')
            this.submitLading = false
            return false
          }
          if (!this.formValidate.locationId) {
            this.$Message.error('请选择公司地址！')
            this.submitLading = false
            return false
          }
          // if (this.formValidate.projectFileList.length === 0) {
          //   this.$Message.error('请上传公司项目！')
          //   this.submitLading = false
          //   return false
          // }
          axios
            .put(
              `/designer_api/job/company/${this.$route.query.id}`,
              this.formValidate
            )
            .then((res) => {
              this.$Message.success('编辑成功!')
              this.submitLading = false
              this.$emit('editCompanySuccess')
            })
            .catch((err) => {
              this.submitLading = false
            })
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    },

    // 上传公司logo
    uploadLogoSuccess(file) {
      if (!file) return false
      this.formValidate.avatarFile = file.data[0]
    },
    // 上传案例
    uploadFilesSuccess(file) {
      if (!file) return false
      console.log(this.formValidate.projectFileList)
      this.formValidate.projectFileList.push(file.data[0])
    },
    initLocation() {
      if (!this.formValidate.locationId) {
        return
      }
      this.addressData.forEach((province) => {
        province.cities.forEach((city) => {
          city.cities.forEach((zone) => {
            if (zone.id === this.formValidate.locationId) {
              this.provinceId = province.id
              this.cityData = province.cities
              this.cityId = city.id
              this.zoneData = city.cities
            }
          })
        })
      })
    },
    changeProvince(pid) {
      this.addressData.forEach((province) => {
        if (province.id === pid) {
          this.cityData = province.cities
          this.zoneData = []
          this.cityId = ''
          this.formValidate.locationId = ''
        }
      })
    },
    changeCity(cid) {
      this.cityData.forEach((city) => {
        if (city.id === cid) {
          this.zoneData = city.cities
          this.formValidate.locationId = ''
        }
      })
    },

    // 当编辑时候，初始化detail
    setCompanyDetail() {
      if (this.companyDetail) {
        Object.assign(this.formValidate, this.companyDetail)
        if (!this.companyDetail.projectFileList) {
          this.$set(this.formValidate, 'projectFileList', [])
        }

        this.initLocation()
      }
    },
  },
  created() {
    this.getOssKey(55)
    const address_name = 'vuejs__ZHULOGIC_ADDRESS' || 'ZHULOGIC_ADDRESS'
    let lists = JSON.parse(localStorage.getItem(address_name)).value
    if (lists) {
      this.addressData = lists
    } else {
      axios.get('/designer_api/location').then((res) => {
        this.addressData = res
        this.initLocation()
      })
    }
    this.address = { ...defaultAddress }

    this.setCompanyDetail()
  },
}
</script>

<style lang="scss" scoped>
.work-company-edit {
  padding: 40px;
  .name-title-edit {
    margin-bottom: 30px;
    .name-title-tag {
      display: inline-block;
      width: 3px;
      background: #e56a69;
      margin-right: 8px;
      vertical-align: middle;
      height: 14px;
      margin-top: -5px;
    }
    .name-title-name {
      font-size: 16px;
      font-weight: bold;
      color: #373737;
    }
  }
  .title {
    margin-top: 60px;
    font-size: 24px;
    font-weight: 500;
    color: #1a1816;
  }
  .form {
    margin-top: 40px;
  }
  /deep/ .ivu-select-selection {
    background-color: #f0f2f5;
    border: none;
  }
  /deep/ .ivu-input {
    background-color: #f0f2f5;
    border: none;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    color: #999;
  }
  /deep/ .slot-con {
    background: #fff;
    width: 150px;
  }
  .upload-view-title {
    font-size: 14px;
    font-weight: 500;
    color: #373737;
    margin-bottom: 5px;
    > span {
      color: red;
    }
  }
  .uoload-view {
    width: 100px;
    height: 100px;
    border-radius: 2px;
    border: 1px dotted #bfbfbf;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
    span.uoload-view-span {
      display: inline-block;
      width: 76px;
      height: 30px;
      background: #f0f2f5;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #373737;
      line-height: 30px;
      margin-top: 35px;
    }
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .upload-desc {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-top: 15px;

    i.icon-jinggao {
      color: #e66a69;
      vertical-align: middle;
    }
  }
  /deep/ .ivu-table th,
  .ivu-table td {
    border-bottom: 1px solid #e8eaec;
  }

  .uoload-view-tabel {
    width: 110px;
    height: 110px;
    border-radius: 2px;
    > span {
      margin-top: 40px;
    }
  }

  .addTabel {
    background: #fafafa;
    border: 1px dotted #d4d4d4;
    width: 100%;
    height: 45px;
    margin-top: 5px;
    &:hover {
      opacity: 0.8;
    }
    cursor: pointer;
    text-align: center;
    line-height: 45px;
    border-radius: 3px;
    > i {
      vertical-align: middle;
    }
  }
  .main-sublit {
    margin-top: 100px;
    text-align: center;
  }

  .upload-desc {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-top: 0px;
    margin-top: -15px;
    margin-left: 78px;
    float: left;
  }

  /deep/ .ivu-progress {
    top: 100%;
    left: -17px;
  }
}
</style>
